<script lang="ts">
  import { defineComponent } from 'vue';
  import MainMenu from '@/components/ui/menus/MainMenu.vue';
  import { MainMenuItems, RouteNames, StatusBarStyles } from '@/helpers/enums';
  import Mixins from '@/helpers/mixins';
  import FlexContainer from '@/components/ui/FlexContainer.vue';

  export default defineComponent({
    components: {
      FlexContainer,
      MainMenu,
    },
    mixins: [Mixins],
    computed: {
      currentMenuItem(): MainMenuItems {
        switch (this.$route?.name) {
          case RouteNames.home:
            return MainMenuItems.home;
          case RouteNames.orders:
            return MainMenuItems.orders;
          case RouteNames.history:
            return MainMenuItems.history;
          case RouteNames.support:
            return MainMenuItems.support;
          default:
            return MainMenuItems.home;
        }
      },
    },
    created(): void {
      this.updateStatusBarStyle(StatusBarStyles.light_content);
    },
    beforeUpdate(): void {
      this.updateStatusBarStyle(StatusBarStyles.light_content);
    },
    methods: {
      switchMenuItem(item: MainMenuItems) {
        switch (item) {
          case MainMenuItems.scan:
            this.openQrScanner();
            this.$store.commit('showLoader');
            break;
          default:
            this.$router.push({ name: item });
            break;
        }
      },
    },
  });
</script>

<template>
  <FlexContainer :disable-insets="[$enums.InsetDirection.top]">
    <div
      class="flex-grow-1 h-100 min-h-0 layout--wrapper sub-page-layout--wrapper position-relative"
    >
      <RouterView v-slot="{ Component }">
        <!--  todo: this is messing up big time
              <TransitionGroup name="fade">
                  <Component :is="Component" :key="$route.fullPath" />
                </TransitionGroup>-->
        <Component :is="Component" :key="$route.fullPath" />
      </RouterView>
      <MainMenu
        :model-value="currentMenuItem"
        class="main-menu--wrapper"
        @update-model-value="switchMenuItem"
      />
    </div>
  </FlexContainer>
</template>

<style lang="scss" scoped>
  .main-menu--wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }
</style>

<style lang="scss">
  .menu-padding {
    padding-bottom: 12.5 * $base-unit;
  }

  .search-button-sticky {
    position: absolute;
    right: 3 * $base-unit;
    bottom: 11 * $base-unit;
    z-index: 20;
  }
</style>
